import { Reveal } from "./Reveal";
import { SectionTitle } from "./SectionTitle";
import { Eyebrow } from "./Eyebrow";
import { certifications } from "@/data/certifications";
import { CertificationLogo } from "./CertificationLogo";

export function RecognitionCards() {
  const items = certifications.slice().sort((a, b) => a.priority - b.priority);
  return (
    <section className="py-20 bg-brand-cream-dark/30">
      <div className="container mx-auto px-4 max-w-5xl">
        <Reveal>
          <div className="text-center mb-12">
            <Eyebrow>Riconoscimenti</Eyebrow>
            <SectionTitle align="center" className="mt-3">
              Quello che ci certifica davvero
            </SectionTitle>
            <p className="text-brand-warm-gray mt-4 font-italic-serif italic">
              Marchi, federazioni e istituzioni che raccontano il nostro lavoro.
            </p>
          </div>
        </Reveal>

        <div className="space-y-6">
          {items.map((c, i) => (
            <Reveal key={c.id} delay={i * 0.05}>
              <article className="bg-brand-cream border-l-4 border-brand-red rounded-sm p-5 md:p-8 grid md:grid-cols-[30%_1fr] gap-6 md:gap-8 items-center">
                <div className="flex items-center justify-center">
                  <div className="relative inline-flex items-center justify-center py-4">
                    <CertificationLogo
                      cert={c}
                      className="max-h-[110px] max-w-[220px] w-auto"
                    />
                    {c.status === "in-progress" && (
                      <span className="absolute -top-2 -right-2 bg-brand-gold text-brand-charcoal text-[10px] tracking-widest uppercase px-2 py-0.5 rounded-sm font-semibold">
                        In corso
                      </span>
                    )}
                  </div>
                </div>
                <div>
                  <h3 className="font-display text-2xl text-brand-charcoal">
                    {c.name}
                  </h3>
                  <p className="font-italic-serif italic text-brand-warm-gray text-sm mt-1">
                    {c.subLabel}
                  </p>
                  <p className="mt-3 text-[15px] leading-[1.7] text-brand-charcoal/85">
                    {c.description}
                  </p>
                  {c.externalLink && (
                    <a
                      href={c.externalLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`${c.name} — scopri di più`}
                      className="inline-block mt-4 text-brand-red font-medium tracking-wide hover:underline"
                    >
                      Scopri di più →
                    </a>
                  )}
                </div>
              </article>
            </Reveal>
          ))}

        </div>
      </div>
    </section>
  );
}